import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { map } from 'rxjs';
import { AnalyticsConsent, ClarityService, PRIVACY_POLICY_URL } from '../../services/clarity.service';

/**
 * Bottom bar asking for consent to analytics cookies (Microsoft Clarity). Shown until the visitor decides,
 * and only where Clarity is configured. The decision can be changed later on the "Prywatność" page.
 */
@Component({
  selector: 'app-analytics-consent-bar',
  standalone: true,
  imports: [AsyncPipe, ButtonModule],
  templateUrl: './analytics-consent-bar.component.html',
  styleUrl: './analytics-consent-bar.component.scss',
})
export class AnalyticsConsentBarComponent {
  private readonly clarity = inject(ClarityService);

  readonly visible$ = this.clarity.consent$.pipe(map((consent) => this.clarity.enabled && consent === null));
  readonly privacyPolicyUrl = PRIVACY_POLICY_URL;

  decide(decision: AnalyticsConsent): void {
    this.clarity.setConsent(decision);
  }
}
